import { MenuOutlined } from '@ant-design/icons';
import { Button, Layout } from 'antd';
import type React from 'react';
import useCheckMobileScreen from '@/app/hooks/useCheckMobileScreen';
import { MOBILE_BREAKPOINT } from '@/const/system';
import { HeaderLanguages, HeaderUser, Rbac } from './components';
import styles from './Header.module.css';

interface HeaderProps {
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header: React.FC<HeaderProps> = ({ setCollapsed }) => {
  const isMobile = useCheckMobileScreen(MOBILE_BREAKPOINT);

  const openHandler = () => setCollapsed(true);

  return (
    <Layout.Header className={styles.wrapper}>
      {isMobile && <Button onClick={openHandler} icon={<MenuOutlined />} />}
      <div className={styles.menuWrapper}>
        <HeaderLanguages />
        <Rbac />
        <HeaderUser />
      </div>
    </Layout.Header>
  );
};

export default Header;
